import styled, { css } from 'styled-components'

import { COOKIE_CONSENT_VIEWS, TCookieConsentView } from './constants'

export const StyledCookieConsent = {
  Overlay: styled.div<{ $view: TCookieConsentView }>`
    position: fixed;
    inset: 0;
    z-index: 100;

    display: flex;
    align-items: ${({ $view }) =>
      $view === COOKIE_CONSENT_VIEWS.BANNER ? 'flex-end' : 'stretch'};
    justify-content: center;
    pointer-events: none;

    ${({ $view }) =>
      $view === COOKIE_CONSENT_VIEWS.PREFERENCES &&
      css`
        background: rgba(9, 10, 10, 0.5);
        pointer-events: auto;
      `}
  `,
}
